import {connectCurrentRefinements} from 'instantsearch.js/es/connectors';

const createDataAttribtues = refinement =>
    Object.keys(refinement)
        .map(key => `data-${key}="${refinement[key]}"`)
        .join(' ');

const getRefinementLabel = function (refinement, translations) {
    if (refinement.attribute === 'colorObject.colorGroupFilter') {
        return `${refinement.value.split(';')[0]}`;
    }
    if (refinement.attribute === 'isPartnerProduct') {
        return `${translations['algolia.search.filter.title.isPartnerProduct.' + refinement.value]}`;
    }
    if (refinement.label === 'true') {
        return `${translations['algolia.search.filter.title.' + refinement.attribute]}`;
    } else {
        return `${refinement.label}`;
    }
};

const renderListItem = function (item, translations) {
    return `${item.refinements.map(
        refinement =>
            `<span class="algolia-chosen-filter" ${createDataAttribtues(refinement)}>
                <a class="label" href="#" title="Filter entfernen" rel="nofollow">
                    <span class="algolia-filter-name">${translations['algolia.search.filter.title.' + refinement.attribute]}</span>
                    <span class="algolia-filter-value">${getRefinementLabel(refinement, translations)}</span>
                    <svg class="icon icon-close">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </a>
            </span>`
    ).join('')}`;
};

const renderPriceListItem = function (item, translations) {
    let dataAttributes1 = createDataAttribtues(item.refinements[0]);
    let dataAttributes2 = createDataAttribtues(item.refinements[1]);
    return `<span class="algolia-chosen-filter" ${dataAttributes1}>
        <span class="dataset-second" ${dataAttributes2}></span>
        <a class="label" href="#" title="Filter entfernen" rel="nofollow">
            <span class="algolia-filter-name">${translations['algolia.search.filter.title.' + item.refinements[0].attribute]}</span>
            <span class="algolia-filter-value">
                ${renderPriceListItemValue(item, translations)}    
            </span>
            <svg class="icon icon-close">
                <use xlink:href="#icon-close"></use>
            </svg>
        </a>
    </span>`;
};

const renderPriceListItemValue = function (item, translations) {
    if (ACC.config.sitePath === 'cz') {
        return `${item.refinements[0].value.toLocaleString("de-DE", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })}&nbsp;${translations['algolia.search.filter.price.currency']}
            &nbsp;-&nbsp;
            ${item.refinements[1].value.toLocaleString("de-DE", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })}&nbsp;${translations['algolia.search.filter.price.currency']}`;
    } else {
        return `${translations['algolia.search.filter.price.currency']}&nbsp;${item.refinements[0].value.toLocaleString("de-DE", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })}
            &nbsp;-&nbsp;
            ${translations['algolia.search.filter.price.currency']}&nbsp;${item.refinements[1].value.toLocaleString("de-DE", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })}`;
    }
}

const rendererFavStoreItem = function (refinement, translations) {
    return `<span class="algolia-chosen-filter" ${createDataAttribtues(refinement)}>
                <a class="label" href="#" title="Filter entfernen" rel="nofollow">
                    <span class="algolia-filter-name">${translations['algolia.search.filter.favourite.clear.label']}</span>
                    <span class="algolia-filter-value">${translations['algolia.search.filter.favourite.clear.label']}</span>
                    <svg class="icon icon-close">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </a>
            </span>`;
}

const renderCustomCurrentRefinements = (renderOptions, isFirstRender) => {
    const {items, refine, widgetParams} = renderOptions;
    let innerHtml = '';
    let priceItems = [];
    const $counterTargets = $('.algolia-panel-filter-counter');
    const $selectionTargets = $('.algolia-panel-filter-selection');
    const $activeFacetsCounter = $('#js-algolia-facets-counter');

    $counterTargets.closest('.ais-Panel-collapseButton').removeClass('btn-filter--active');
    $selectionTargets.empty();

    items.map(item => {
        const refinements = item.refinements;
        const $counterTarget = $('.algolia-panel-filter-counter-' + item.attribute.replaceAll('.', '_'));
        const $selectionTarget = $('.algolia-panel-filter-selection-' + item.attribute.replaceAll('.', '_'));


        if (refinements.length > 0) {
            const appliedFacetValues = refinements?.reduce(function (acc, refinement, index) {
                return `${acc}${index === 0 ? '' : ', '}${getRefinementLabel(refinement, widgetParams.translations)}`;
            }, '');

            $counterTarget
                .text(item.refinements.length)
                .closest('.ais-Panel-collapseButton')
                .addClass('btn-filter--active');
            $selectionTarget.text(appliedFacetValues);
        }

        if (item.attribute == 'availableStoresList') {
            //do not render the store filter in the list, except when it is the Fav store
            let favouritePos = $("#favourite-store-button").data('fav')
            if (favouritePos === undefined || favouritePos === '') {
                return;
            }
            refinements.map(refinement => {
                if (refinement.value === favouritePos) {
                    innerHtml += rendererFavStoreItem(refinement, widgetParams.translations);
                }
            });
        } else if (item.attribute !== 'price') {
            innerHtml += renderListItem(item, widgetParams.translations);
        } else {
            innerHtml += renderPriceListItem(item, widgetParams.translations);
        }
    });

    widgetParams.container.innerHTML = `${innerHtml}`;

    [...widgetParams.container.querySelectorAll('.algolia-chosen-filter')].forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            if (event.currentTarget.dataset.attribute !== 'price') {
                const item = Object.keys(event.currentTarget.dataset).reduce(
                    (acc, key) => ({
                        ...acc,
                        [key]: event.currentTarget.dataset[key],
                    }),
                    {}
                );
                if (item.attribute === 'departmentName') {
                    sessionStorage.setItem('genderPreSelection', '');
                }
                refine(item);
            } else {
                let $current = $(event.currentTarget);
                let $second = $current.find('.dataset-second');
                const item1 = Object.keys($current[0].dataset).reduce(
                    (acc, key) => ({
                        ...acc,
                        [key]: $current[0].dataset[key],
                    }),
                    {}
                );
                const item2 = Object.keys($second[0].dataset).reduce(
                    (acc, key) => ({
                        ...acc,
                        [key]: $second[0].dataset[key],
                    }),
                    {}
                );
                refine(item1);
                refine(item2);
            }
        });
    });

    if (items.length) {
        $activeFacetsCounter.text(items.length)
    } else {
        $activeFacetsCounter.empty();
    }
};

// Create the custom widget
const customCurrentRefinements = connectCurrentRefinements(
    renderCustomCurrentRefinements
);

export {customCurrentRefinements};